// extracted by mini-css-extract-plugin
module.exports = {"container":"FloatingWindow__container__-LEbd","backDrop":"FloatingWindow__backDrop__2D8x0","btn_close":"FloatingWindow__btn_close__1r-ny","hidden":"FloatingWindow__hidden__hJlhj"};